import React from "react";
import { motion } from "framer-motion";
import {
  Factory,
  Truck,
  ShieldCheck,
  Headphones,
  Leaf,
  Banknote,
} from "lucide-react";

const reasons = [
  {
    icon: Factory,
    title: "Yerli Üretim",
    desc: "Tüm ürünlerimiz kendi tesislerimizde, kontrollü kalitede üretilir.",
  },
  {
    icon: Banknote,
    title: "B2B Fiyat Avantajı",
    desc: "Halı yıkama firmalarına özel toptan fiyatlandırma ve uzun vadeli iş ortaklığı.",
  },
  {
    icon: Truck,
    title: "Hızlı Gönderim",
    desc: "Türkiye'nin her yerine, kesintisiz tedarik ve hızlı kargo.",
  },
  {
    icon: ShieldCheck,
    title: "Kalite Garantisi",
    desc: "Test edilmiş formüller ve dayanıklı ambalaj malzemeleri.",
  },
  {
    icon: Leaf,
    title: "Çevreci Yaklaşım",
    desc: "%100 çevreci paketleme ve halıya zarar vermeyen formüller.",
  },
  {
    icon: Headphones,
    title: "7/24 Destek",
    desc: "Telefon ve WhatsApp ile her zaman ulaşabileceğiniz müşteri desteği.",
  },
];

const WhyUs = () => {
  return (
    <section
      id="ozellikler"
      data-testid="whyus-section"
      className="py-20 lg:py-28 bg-white border-y border-slate-100"
    >
      <div className="container mx-auto px-6 lg:px-8 max-w-7xl">
        <div className="max-w-3xl">
          <div className="text-xs font-bold tracking-[0.28em] uppercase text-[#2563EB]">
            Neden HALIPAK?
          </div>
          <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl text-[#0A192F] leading-[1.05] tracking-tight">
            Halı yıkamacıların <span className="text-[#2563EB]">tercih ettiği</span>{" "}
            6 sebep.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`why-card-${i}`}
                className="group relative rounded-2xl border border-slate-200 bg-[#F8FAFC] p-7 hover:bg-white hover:border-[#2563EB]/40 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0A192F]/5 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#0A192F] grid place-items-center mb-5 group-hover:bg-[#2563EB] transition-colors">
                  <Icon className="w-5.5 h-5.5 text-white" strokeWidth={2.2} />
                </div>
                <h3 className="font-heading font-bold text-[#0A192F] text-lg leading-tight">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{r.desc}</p>
                <div className="absolute top-5 right-5 text-[10px] font-mono font-bold text-slate-300">
                  0{i + 1}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
